/*
 * @Description: 自定义推广详情页面数据（单店或者多店）
 * @Author: kayvor
 * @Date: 2020-10-15 15:25:40
 * @LastEditors: kayvor
 * @LastEditTime: 2021-01-27 16:46:05
 */
import ajax from '../http/ajax'

export const getPromotionInfo = (params) => {
    return ajax.get('getPromotionInfo', params)
}

export const getPromotionStoreInfo = (params) => {
    return ajax.get('getBusinessSstoreListMap', params)
}

export const getPromotionGoodsInfo = (params) => {
    return ajax.get('getPromotionGoodsInfo', params)
}

export const getStoreInfo = (params) => {
    return ajax.get('getStoreInfo', params)
}

export const getPromotionFloorInfo = (params) => {
    return ajax.get('getPromotionFloorInfo', params)
}

// 反馈
export const doFeedback = (params) => {
    return ajax.post('feedback', params)
}

// 扫物料码获取最近门店
export const getScanSstore = (params) => {
    return ajax.get('getScanSstore', params)
}
